   $(document).ready(function(){
      $(".itg-img-detail").hide();
      $("p.caption-neue.itg-detail").click(function(){
        $(".itg-img-detail").show();
        $(".itg-img-back").hide();
        $(".itg-img-front").hide();
      });
      $(".itg-img-back").hide();
      $("p.caption-neue.itg-back").click(function(){
        $(".itg-img-detail").hide();
        $(".itg-img-back").show();
        $(".itg-img-front").hide();
     });
     $("p.caption-neue.itg-front").click(function(){
        $(".itg-img-detail").hide();
        $(".itg-img-back").hide();
        $(".itg-img-front").show();
     });
     if($(window).width() > 767){
      	$('ul.itg-tabs li').click(function(){
          $('ul.itg-tabs li').removeClass('current');
          $(this).addClass('current');
          $('.tab-content').hide();
          var tab_id = $(this).attr('data-tab');
          $("#"+tab_id).find('.itg-slider').slick('refresh');
          $("#"+tab_id).find('.itg-fit-text').slick('refresh');
          $("#"+tab_id).show();
      	});
          $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
      });
      $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        infinite: true,
        arrows: true,
        nextArrow:'<div class="itg-next">NEXT <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="1 0 10 8" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.05484 7.35335L8.869 4.47113L0.550415 4.4157L0.568114 3.56582L8.9044 3.54734L6.07254 0.628175L6.67431 -2.5358e-07L10.5504 3.99076L6.65661 8L6.05484 7.35335Z" fill="currentColor"></path></svg></div>',
        prevArrow:'<div class="itg-prev"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.49558 7.35335L1.68142 4.47113L10 4.4157L9.9823 3.56582L1.64602 3.54734L4.47788 0.628175L3.87611 -2.5358e-07L-1.84144e-07 3.99076L3.89381 8L4.49558 7.35335Z" fill="currenColor"></path></svg> PREVIOUS</div>',
        centerMode: true,
        focusOnSelect: true,
           responsive: [
           {
             breakpoint: 1024,
             settings: {
               slidesToShow: 5,
               slidesToScroll: 1,
               infinite: true,
               dots: false
             }
           },
             {
             breakpoint: 900,
              settings: {
               slidesToShow: 3,
               slidesToScroll: 1
              }
             },
           {
             breakpoint: 600,
              settings: {
               slidesToShow: 2,
               slidesToScroll: 1
             }
           },
           {
             breakpoint: 480,
             settings: {
               slidesToShow: 1,
               slidesToScroll: 1
             }
           }
         ]
      });
     }

       if($(window).width() < 767){
      	$('ul.itg-tabs li').click(function(){
          $('ul.itg-tabs li').removeClass('current');
          $(this).addClass('current');
          $('.tab-content').hide();
          var tab_id = $(this).attr('data-tab');
          // $("#"+tab_id).find('.itg-slider').slick('refresh');
          // $("#"+tab_id).find('.itg-fit-text').slick('refresh');
          $("#"+tab_id).show();
             $(".itg-fit-guide-content[data-value='0']").show();
      	});
       $(".itg-fit-guide-content").hide();
       $(".itg-fit-guide-content[data-value='0']").show();
          $("#itg-size-select-1").change(function() {
            var this_v = $(this).val();
             $(".itg-fit-guide-content").hide();
            $(this).closest('.itg-container.size-mobile').find(".itg-fit-guide-content").each(function() {
              var slider_index = $(this).data('value');
              if (slider_index == this_v) {
               $(this).show();
              }
            });
          });
          $("#itg-size-select-2").change(function() {
            var this_v = $(this).val();
             $(".itg-fit-guide-content").hide();
            $(this).closest('.itg-container.size-mobile').find(".itg-fit-guide-content").each(function() {
              var slider_index = $(this).data('value');
              if (slider_index == this_v) {
               $(this).show();
              }
            });
          });
          $("#itg-size-select-3").change(function() {
            var this_v = $(this).val();
             $(".itg-fit-guide-content").hide();
            $(this).closest('.itg-container.size-mobile').find(".itg-fit-guide-content").each(function() {
              var slider_index = $(this).data('value');
              if (slider_index == this_v) {
               $(this).show();
              }
            });
          });
          $("#itg-size-select-4").change(function() {
            var this_v = $(this).val();
             $(".itg-fit-guide-content").hide();
            $(this).closest('.itg-container.size-mobile').find(".itg-fit-guide-content").each(function() {
              var slider_index = $(this).data('value');
              if (slider_index == this_v) {
               $(this).show();
              }
            });
          });
          $("#itg-size-select-5").change(function() {
            var this_v = $(this).val();
             $(".itg-fit-guide-content").hide();
            $(this).closest('.itg-container.size-mobile').find(".itg-fit-guide-content").each(function() {
              var slider_index = $(this).data('value');
              if (slider_index == this_v) {
               $(this).show();
              }
            });
          });
      }
       // Custom Collection infinite scroll
    $(window).on('scroll', function() {
      if( $(document).find('#more a').hasClass('loading') ){
        
      }else{
        $(document).find('#more a').addClass('loading').click();
      }
    });
    $(document).on('click','#more a',function(e) {
      e.preventDefault();
      var scrollURL = $(this).attr("href");
      $.ajax({
         type: 'GET',
         url: scrollURL,
         beforeSend: function(){},
         success: function(data) {
            $(document).find("#more").remove();  
             if( $(data).find("#more").length ){                 
               var moreButton = $(data).find("#more").html();
               $(document).find("#more").html(moreButton);  
             }else{                 
               $(document).find("#more").remove();  
               $(document).find('.order_2').addClass('active');
             }
             var filteredData = $(data).find("#main-collection-product-grid").html();
             $(document).find("#main-collection-product-grid").append(filteredData);             
         },
         dataType: "html"
     });
  });
     $('.collection_list_Slider').slick({
      slidesToShow: 4,
      fade: false,
      dots: false,
      arrows: true,
      nextArrow:'<button class="itg-next btn slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
      prevArrow:'<button class="itg-prev btn slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
      responsive: [
             {
             breakpoint: 900,
              settings: {
               slidesToShow: 3,
               slidesToScroll: 1
              }
             },
           {
             breakpoint: 600,
              settings: {
               slidesToShow: 2,
               slidesToScroll: 1
             }
           },
           {
             breakpoint: 480,
             settings: {
               slidesToShow: 1,
               slidesToScroll: 1
             }
           }
         ]
     });
});